import {
  EV_CALCULATOR_URL,
  EV_CHARGER_URL,
  EV_REBATES_URL,
  EV_SOFTWARE_URL,
  OCPP_URL,
  OPEN_ADR_URL
} from "evcharging/app/seo/urls";

export interface PageMetadata {
  title: string;
  description: string;
}

interface PagesMetadata {
  [key: string]: PageMetadata;
}

const defaultMetadata = {
  title: `Energy Efficiency for Homes and Businesses`,
  description:
    'Boost comfort and cut costs with smart energy solutions for homes and businesses. From EV rebates to substantial energy savings, we help reduce energy use and lower utility bills.'
};

const pagesMetadata: PagesMetadata = {
  '/about-us': {
    title: 'Learn what Energy5 stands for and how it came to be',
    description:
      'Discover Energy5 – an energy management platform like no other – Retail Energy management, LED retrofitting, EV Charging – all under one roof!',
  },
  '/our-providers': {
    title: 'Learn more about our esteemed providers',
    description:
      'Discover some of the most reputable companies in the industry who teamed up with Energy5 to deliver excellence and reshape the entire industry landscape.',
  },
  '/contact-us': {
    title: `Get in touch & gain control over your energy management`,
    description:
      'Contact us to learn how we can help you achieve complete energy efficiency and save on energy at the same time.',
  },
  '/faq': {
    title: 'Get answers to Retail Energy, LED, and EVC questions you have',
    description:
      'If you’re curious about switching your energy supplier, performing an LED retrofit, or installing EV chargers, this section will get you through all the details.',
  },
  '/privacy': {
    title: `Privacy Policy`,
    description: 'Learn how we use your personal data and why energy providers require it.',
  },
  '/terms': {
    title: `Terms and Conditions`,
    description:
      'Read our terms and conditions and use Energy5 to switch your gas & electricity providers on the go.',
  },
  '/compare-energy-rates/business': {
    title: 'Safeguard your business with the best fixed energy rates',
    description:
      'Reduce your business electricity prices and easily compare electricity rates from the top business energy suppliers',
  },
  '/compare-energy-rates': {
    title: 'Looking for the best fixed electricity rates?',
    description:
      'Be it business or residential electricity rates, just fill the form and get the best energy plans in your area. Start save on energy today',
  },
  '/compare-energy-rates-2': {
    title: 'Looking for the best fixed electricity rates?',
    description:
      'Be it business or residential electricity rates, just fill the form and get the best energy plans in your area. Start save on energy today',
  },
  '/retail/energy-rates': {
    title: 'Energy rates',
    description: 'Compare and select electricity & gas rates',
  },
  '/retail/business/customer-information': {
    title: 'Customer Information',
    description: 'Create your contract to switch your energy company',
  },
  '/retail/business/utility-account-information': {
    title: 'Utility Account Information',
    description: 'Add energy customer profile',
  },
  '/retail/business/billing-address': {
    title: 'Billing Address',
    description: 'Billing Address',
  },
  '/retail/business/confirmation': {
    title: 'Confirmation',
    description: 'Place your order to switch your energy supplier',
  },
  '/retail/business/success': {
    title: 'Success',
    description: 'Your order has been placed',
  },
  '/retail/home/customer-information': {
    title: 'Customer Information',
    description: 'Create your contract to switch your energy company',
  },
  '/retail/home/utility-account-information': {
    title: 'Utility Account Information',
    description: 'Add energy customer profile',
  },
  '/retail/home/confirmation': {
    title: 'Confirmation',
    description: 'Place your order to switch your energy supplier',
  },
  '/retail/home/success': {
    title: 'Success',
    description: 'Your order has been placed',
  },
  '/thank-you': {
    title: 'Thank You',
    description: 'Thank You',
  },
  '/document-declined': {
    title: 'Document Declined',
    description: 'Document Declined',
  },
  /*'/blog': {
    title: 'Discover energy efficiency, energy savings & energy industry',
    description:
      'Read our blog to learn how to save on energy, get energy industry insights, explore energy efficiency, and gets valuable tips, tricks & recommendations.',
  },*/
  '/scan-electricity-bill': {
    title: `Scan electricity bill`,
    description: 'Scan electricity bill',
  },
  '/ev-charging': {
    title: 'Energy-efficient, cost-cutting, eco-friendly EVC solutions',
    description:
      'One-stop marketplace for EVC. Find cutting-edge chargers, get them installed, gain full control over their operations via proprietary software and enjoy the perks.',
  },
  [EV_REBATES_URL]: {
    title: 'Get a incentive for EV charger',
    description:
      'Find a incentive for installing an EVcharger or several on your premises. Save big time in no time with turnkey solutions.',
  },
  [EV_CHARGER_URL]: {
    title: 'Level 2 EV charging solutions',
    description:
      'EV hardware - best level 2 EV charger for your business. Get EV charging station profit through all-in-one solutions.',
  },
  [EV_SOFTWARE_URL]: {
    title: 'Efficient EV charging software',
    description:
      'The right EV charging management software for businesses. Part of a full suite of tailored EV charging solutions.',
  },
  [EV_CALCULATOR_URL]: {
    title: 'EV Charging ROI calculator',
    description:
      'An electric car charging profit calculator to determine how much revenue you can expect from EV charging infrastructure.',
  },
  [OCPP_URL]: {
    title: 'EV Charging OCPP',
    description: 'OCPP and its significance to EV Charging.',
  },
  [OPEN_ADR_URL]: {
    title: 'EV Charging OpenADR',
    description:
      'OpenADR allows businesses to reduce electricity use during demand response events automatically',
  },
  '/lighting-retrofit': {
    title: 'Perform a lighting audit and upgrade your lighting',
    description:
      'Upgrade your lighting to energy-efficient LEDs, save on energy and minimize your carbon footprint, carry out a lighting audit independently!',
  },
};

const getPageMetadata = (asPath: string): PageMetadata => {
  const routes = Object.keys(pagesMetadata);
  for (const route of routes) {
    if (new RegExp(route).test(asPath)) {
      return { ...pagesMetadata[route] };
    }
  }
  return defaultMetadata;
};

export const AW_ID = 'AW-326981088/kWUDCJ6bm6oDEOCr9ZsB';

export default getPageMetadata;
